import { type Ref, ref, type UnwrapRef } from 'vue';

export function useDirtyRef<T extends object>(target: Ref<T>) {
    const original = ref<UnwrapRef<T>>({} as UnwrapRef<T>);

    const resetDirty = () => {
        original.value = JSON.parse(JSON.stringify(target.value));
    };

    resetDirty();

    const getDirty = (): Partial<T> => {
        const changed = {} as Partial<T>;
        for (const key in target.value) {
            if (JSON.stringify(target.value[key]) !== JSON.stringify(original.value[key])) {
                changed[key as keyof T] = target.value[key as keyof T];
            }
        }
        return changed;
    };

    const isDirty = (): boolean => {
        return Object.keys(getDirty()).length > 0;
    };

    return {
        getDirty,
        isDirty,
        resetDirty,
    };
}
